import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TextFieldSizes from './TextFieldSizes';
import ClientProvider from './client';
export default createDemo(import.meta.url, TextFieldSizes, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/text-fields/demos/sizes/TextFieldSizes.tsx",
    "fileName": "TextFieldSizes.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport TextField from '@mui/material/TextField';\n\nexport default function TextFieldSizes() {\n  return (\n    <Box\n      component=\"form\"\n      sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}\n      noValidate\n      autoComplete=\"off\"\n    >\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <div>\n        <TextField\n          label=\"Size\"\n          id=\"outlined-size-small\"\n          defaultValue=\"Small\"\n          size=\"small\"\n        />\n        <TextField label=\"Size\" id=\"outlined-size-normal\" defaultValue=\"Normal\" />\n      </div>\n      <div>\n        <TextField\n          label=\"Size\"\n          id=\"filled-size-small\"\n          defaultValue=\"Small\"\n          variant=\"filled\"\n          size=\"small\"\n        />\n        <TextField\n          label=\"Size\"\n          id=\"filled-size-normal\"\n          defaultValue=\"Normal\"\n          variant=\"filled\"\n        />\n      </div>\n      <div>\n        <TextField\n          label=\"Size\"\n          id=\"standard-size-small\"\n          defaultValue=\"Small\"\n          size=\"small\"\n          variant=\"standard\"\n        />\n        <TextField\n          label=\"Size\"\n          id=\"standard-size-normal\"\n          defaultValue=\"Normal\"\n          variant=\"standard\"\n        />\n      </div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 53,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport TextField from '@mui/material/TextField';\n\nexport default function TextFieldSizes() {\n  return (\n    <Box\n      component=\"form\"\n      sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}\n      noValidate\n      autoComplete=\"off\"\n    >\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <div>\n        <TextField\n          label=\"Size\"\n          id=\"outlined-size-small\"\n          defaultValue=\"Small\"\n          size=\"small\"\n        />\n        <TextField label=\"Size\" id=\"outlined-size-normal\" defaultValue=\"Normal\" />\n      </div>\n      <div>\n        <TextField\n          label=\"Size\"\n          id=\"filled-size-small\"\n          defaultValue=\"Small\"\n          variant=\"filled\"\n          size=\"small\"\n        />\n        <TextField\n          label=\"Size\"\n          id=\"filled-size-normal\"\n          defaultValue=\"Normal\"\n          variant=\"filled\"\n        />\n      </div>\n      <div>\n        <TextField\n          label=\"Size\"\n          id=\"standard-size-small\"\n          defaultValue=\"Small\"\n          size=\"small\"\n          variant=\"standard\"\n        />\n        <TextField\n          label=\"Size\"\n          id=\"standard-size-normal\"\n          defaultValue=\"Normal\"\n          variant=\"standard\"\n        />\n      </div>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 53,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/TextField"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
